var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-table-lite',{attrs:{"items":_vm.table_items,"borderless":true,"small":true,"thead-class":"info_table_class"},scopedSlots:_vm._u([{key:"cell(html)",fn:function(data){return [_c('span',{domProps:{"innerHTML":_vm._s(data.value)}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }